// API环境配置
const ENV_CONFIG = {
    TEST: {
        // baseURL: 'http://192.168.31.25:8088/',
        baseURL: 'https://testdzlapi.cpolar.top/',
        sendURL: 'https://test-send.cpolar.top/',
        nettyURL: 'http://1.193.163.25:8711/',
        lklURL: 'https://dzlapi.cpolar.cn/lkl/'
    },
    PROD: {
        baseURL: 'https://dzlapi.rcdqiot.com/',
        sendURL: 'https://send.rcdqiot.com/',
        nettyURL: 'https://sendnetty.cpolar.top',
        lklURL: 'https://dzlapi.rcdqiot.com/lkl/'
    }
};
// 当前环境配置
const currentEnv = 'PROD'; 
// 可切换为 'PROD''TEST'
window.sessionStorage.setItem('开发模式',currentEnv);
const config = ENV_CONFIG[currentEnv];
import axios from 'axios';
// 创建axios实例
const h1 = axios.create({ baseURL: config.baseURL });
const h2 = axios.create({ baseURL: config.sendURL });
const h3 = axios.create({ baseURL: config.nettyURL });
// URL配置
export const imgUrl = config.baseURL + 'station/';
export const imgUrls = config.baseURL + 'img/';
export const imgUrls2 = config.baseURL + 'kc/';
export const imgUrls3 = config.lklURL;
// 请求拦截器
const setupInterceptors = (instance) => {
    instance.interceptors.request.use((config) => {
        config.headers = {
            ...config.headers,
            token: window.sessionStorage.getItem('token') || '',
            'Captcha-Id': window.sessionStorage.getItem('CaptchaId') || '',
        };
        return config;
    });
};
// 为所有实例添加拦截器
setupInterceptors(h1);
setupInterceptors(h2);
setupInterceptors(h3);
export default {
    h1, h2, h3, imgUrl, imgUrls, imgUrls2, imgUrls3
};
